import { store } from 'store';
import { EventsSettingsInterface } from 'store/reducers/visualisations/types';
import { updateEventSettingsAction } from 'store/reducers/visualisations/actions';

const dispatch = store.dispatch;

export const onEventsChange = (events: EventsSettingsInterface) => dispatch(updateEventSettingsAction(events));
